import React from 'react'
import PropTypes from 'prop-types'
import {useMediaQuery} from '@chakra-ui/react'
import {MenuTemplate} from './MenuTemplate'
import {DrawerTemplate} from '../../drawer-menu/DrawerTemplate'

const TEMPLATE_VARIANT_BY_TYPE = {
    menu_redesign_template_1: 'template-one',
    menu_redesign_template_2: 'template-two',
    menu_redesign_template_3: 'template-three',
    menu_redesign_template_4: 'template-four',
}

const MenuContent = ({primarycategory, categoriesData, locale}) => {
    const templateType = primarycategory?._content_type_uid
    const variant = TEMPLATE_VARIANT_BY_TYPE[templateType]
    const [isMobileMenu] = useMediaQuery('(max-width: 1199px)')

    if (!variant) return null

    if (isMobileMenu) {
        return (
            <DrawerTemplate
                primarycategory={primarycategory}
                categoryData={categoriesData}
                locale={locale}
                variant={variant}
            />
        )
    }

    return (
        <MenuTemplate
            primarycategory={primarycategory}
            categoryData={categoriesData}
            locale={locale}
            variant={variant}
        />
    )
}

MenuContent.propTypes = {
    primarycategory: PropTypes.object,
    categoriesData: PropTypes.object,
    locale: PropTypes.object,
}

export {MenuContent}
